import { Button, Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useRecoilValue } from 'recoil'
import { toFarsiDigits } from '../../assets/utils'
import { userInfoState } from '../../recoil/atoms'
import LockIcon from '@material-ui/icons/Lock';
import UserProfileCard from '../common/UserProfileCard'

const ConsultantInfo = props => {
    const userInfo = useRecoilValue(userInfoState)
    const ui = props.userInfo || userInfo || {}

    return (
        <UserProfileCard
            title='مشخصات مشاور'
            name={ui.name}
            code={ui.national_code}
            codeLabel='شناسه ملی'
            logo={ui.logo}
            extra={
                <>
                    <Grid item xs={4}>
                        <Typography variant='h6'>
                            شماره ثبت: {toFarsiDigits(ui.registration_number) || 'وارد نشده'}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant='h6'>
                            کد معاملاتی: {toFarsiDigits(ui.brokerage_account) || 'وارد نشده'}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant='h6'>
                            کد اقتصادی: {toFarsiDigits(ui.economic_code) || 'وارد نشده'}
                        </Typography>
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: 'center' }}>
                        <Button
                            variant='contained'
                            color='primary'
                            disabled={!ui.restriction}
                            onClick={() => props.setOpenRestrictions && props.setOpenRestrictions('globalRestrictions')}
                        >
                            <Typography>
                                محدودیت ها
                            </Typography>
                            {!userInfo.is_subscribed && <LockIcon />}
                        </Button>
                    </Grid>
                </>
            }
        />
    )
}

export default ConsultantInfo
